/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
// import BackgroundImage from "gatsby-background-image"
// import { useStaticQuery, graphql } from "gatsby"
// import styled from "styled-components"
import "./bio.scss"
import { Link } from "gatsby"

const Bio = () => {
  // const data = useStaticQuery(graphql`
  //   query banner {
  //     imageSharp(id: { eq: "eb040562-1783-5e6c-8d94-81cdddd73364" }) {
  //       fluid {
  //         ...GatsbyImageSharpFluid_withWebp
  //       }
  //     }
  //   }
  // `)

  // const BannerBackgroundImage = styled(BackgroundImage)`
  //   width: 100%;
  //   height: 100vh;
  //   opacity: 1 !important;
  //   background-size: cover;
  //   background: linear-gradient(to bottom, transparent 17.75%, black 99.89%);
  //   background-size: cover;
  // `

  // const bannerData = data.imageSharp.fluid
  // Set these values by editing "siteMetadata" in gatsby-config.js

  return (
    <div className="bio">
      {/* TODO: use and style a banner image */}
      {/* <BannerBackgroundImage
        className="bio-banner"
        formats={["auto", "webp", "avif"]}
        fluid={bannerData}
        quality={100}
        alt="Banner picture"
      ></BannerBackgroundImage> */}
      <Link to="/">
        <StaticImage
          className="bio-avatar"
          layout="fixed"
          formats={["auto", "webp", "avif"]}
          src="../images/avatar.jpg"
          width={115}
          height={115}
          quality={100}
          alt="Profile picture"
        />
      </Link>
      {/* <small className="bioText">bearer of the curse</small> */}
    </div>
  )
}

export default Bio
